// Downscale a profile image to a small JPEG data URL before handing it to
// @react-pdf/renderer. The bundled fontkit/PDFKit decodes the source image
// into a fixed 128MB WASM heap and aborts on multi-MB originals; a ~256px
// JPEG stays well under that ceiling on every candidate.

const FALLBACK_QUALITY = 0.82;
const FALLBACK_SIZE = 320;

export const resizeImageForPDF = (src, maxSize = FALLBACK_SIZE, quality = FALLBACK_QUALITY) => {
    if (!src) return Promise.resolve(null);

    return new Promise((resolve) => {
        const img = new window.Image();
        img.crossOrigin = "anonymous";

        img.onload = () => {
            try {
                const ratio = Math.min(1, maxSize / Math.max(img.width, img.height));
                const w = Math.max(1, Math.round(img.width * ratio));
                const h = Math.max(1, Math.round(img.height * ratio));

                const canvas = document.createElement("canvas");
                canvas.width = w;
                canvas.height = h;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, w, h);

                resolve(canvas.toDataURL("image/jpeg", quality));
            } catch (err) {
                // Canvas tainted by cross-origin image, or other draw failure.
                // Fall back to the original src so the PDF still renders with
                // the original (potentially large) image rather than no photo.
                resolve(src);
            }
        };

        img.onerror = () => resolve(src);
        img.src = src;
    });
};
